import { Component, OnInit, Input, ViewChild, OnChanges } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material";
import { cloneDeep } from "lodash";
import { Options } from "fullcalendar";
import { CalendarComponent } from "ng-fullcalendar";
import * as moment from "moment";
import { Scheduling, Schedule } from "../scheduling.model";
import { SchedulingCreateDialogComponent } from "./scheduling-create-dialog/scheduling-create-dialog.component";
import { DevicesService } from "../../devices/devices.service";
import { Constants } from "../../../core/services/constants";
import { SchedulingService } from "../scheduling.service";
import { SchedulingUtils } from "../shedulling.utils";
import {
  ScheduleType,
  Constants as Constants2,
  ClientTariff,
} from "../../../shared/constants";
import { MacroGroupDTO } from "../../../shared/DTO/MacroGroupsDTO";
import { SessionStateService } from "../../../core/services/session-state.service";
import { GeneralService } from "../../../shared/services/general.service";
import { Device } from "../../devices/devices.model_new";
import { RuleDTO, RuleWrapperDTO } from "../../../shared/DTO/RuleDTO";
import {
  SCHEDULE_TYPE,
  EVENT_COLOR,
  MODE,
  SchedulingType,
  RULE_STATUS,
} from "../scheduling.constants";
import { GROUP } from "../../devices/devices.constant";
import { HOUSE_TARIFF, HOUSE_COUNTRIES } from "../../houses/houses.constants";
import { element } from "protractor";
import { Observable } from "rxjs";
import { HVACModel } from "../../devices/devices.utils";
import { DeleteConfirmDialogComponent } from "../../../shared/components/delete-confirm-dialog/delete-confirm-dialog.component";
import { Router } from "@angular/router";
import { empty } from "rxjs/Observer";
import { of } from "rxjs/observable/of";

@Component({
  selector: "app-scheduling-device.",
  templateUrl: "./scheduling-device.component.html",
  styleUrls: ["./scheduling-device.component.scss"],
})
export class SchedulingDeviceComponent implements OnInit, OnChanges {
  @Input() device: Device;
  loading = false;
  loadingONOFF = false;
  loadingStandbyKiller = false;
  scheduling: Scheduling = new Scheduling();
  schedulingEconomic: Scheduling = new Scheduling();
  schedulingStandbyKiller: Scheduling = new Scheduling();
  desiredSchedules: Schedule[] = [];
  scheduleType: SCHEDULE_TYPE;
  SchedulingUtils = SchedulingUtils;
  viewCalendar: boolean;
  hvacModel: HVACModel;
  termostatModel = true;
  isTariffSimple = true;

  showOnOff = true;
  showEconomic = true;
  showSetpoint = true;
  showDisabled = true;
  showInactive = true;
  showStandbyKIller = true;
  isSpainCountry = false;

  dialogRef: MatDialogRef<SchedulingCreateDialogComponent>;
  dialogDelRef: MatDialogRef<DeleteConfirmDialogComponent>;
  @ViewChild(CalendarComponent) ucCalendar: CalendarComponent;
  calendarOptions: Options;

  constructor(
    private devicesService: DevicesService,
    private schedulingService: SchedulingService,
    private sessionStateService: SessionStateService,
    private generalService: GeneralService,
    private router: Router,
    private dialog: MatDialog
  ) {}

  ngOnChanges() {
    this.loading = true;
    if (this.device.getGroups().has(GROUP.SWITCH)) {
      this.scheduleType = SCHEDULE_TYPE.ON_OFF;
    } else if (this.device.getGroups().has(GROUP.HVAC)) {
      this.scheduleType = SCHEDULE_TYPE.HVAC;
    } else if (this.device.getGroups().has(GROUP.THERMOSTAT)) {
      this.scheduleType = SCHEDULE_TYPE.THERMOSTAT;
    }
    this.getScheduling();
  }
  ngOnInit() {
    this.isSpainCountry =
      this.sessionStateService.getHouse().country === HOUSE_COUNTRIES.SPAIN;
    this.loading = true;
    if (this.device.getGroups().has(GROUP.SWITCH)) {
      this.scheduleType = SCHEDULE_TYPE.ON_OFF;
    } else if (this.device.getGroups().has(GROUP.HVAC)) {
      this.scheduleType = SCHEDULE_TYPE.HVAC;
    } else if (this.device.getGroups().has(GROUP.THERMOSTAT)) {
      this.scheduleType = SCHEDULE_TYPE.THERMOSTAT;
    }
    this.getScheduling();
  }

  getScheduling() {
    this.scheduling = new Scheduling();
    this.schedulingService
      .getScheduling(
        this.sessionStateService.getHouse().houseId,
        this.device.getModuleId(),
        this.scheduleType
      )
      .map(
        (scheduling) => {
          this.scheduling = scheduling;
          this.addDesiredSchedules(scheduling.getSchedules());
        }
        //err => console.log(err)
      )
      .flatMap(() => {
        if (!this.schedulingService.economicTariffs) {
          return this.schedulingService.getEconomicTariffs();
        } else {
          return Observable.empty();
        }
      })
      .catch((e: any) => of(false))
      .finally(() => (this.loading = false))
      .subscribe((res) => {});
    if (
      this.scheduleType === SCHEDULE_TYPE.ON_OFF &&
      this.sessionStateService.getHouseTariff().tariff !== HOUSE_TARIFF.SIMPLE
    ) {
      this.isTariffSimple = false;
      this.schedulingService
        .getScheduling(
          this.sessionStateService.getHouse().houseId,
          this.device.getModuleId(),
          SCHEDULE_TYPE.ECONOMIC
        )
        .catch((e: any) => of(false))
        .finally(() => (this.loadingONOFF = false))
        .subscribe(
          (scheduling) => {
            if (scheduling) {
              this.schedulingEconomic = scheduling;
              this.addDesiredSchedules(scheduling.getSchedules());
            }
          },
          (err) => {
            // console.log(err);
          }
        );
    } else {
      this.loadingONOFF = true;
    }

    this.loadingStandbyKiller = true;
    this.schedulingService
      .getScheduling(
        this.sessionStateService.getHouse().houseId,
        this.device.getModuleId(),
        SCHEDULE_TYPE.STAND_BY_KILLER
      )
      .catch((e: any) => of(false))
      .finally(() => (this.loadingStandbyKiller = false))
      .subscribe((scheduling) => {
        if (scheduling) {
          this.schedulingStandbyKiller = scheduling;
          this.addDesiredSchedules(scheduling.getSchedules());
        }
      });
    if (this.scheduleType === SCHEDULE_TYPE.HVAC) {
      this.devicesService
        .getHavcBrandsandModel(
          this.device.getUserAttribute("brand"),
          this.device.getUserAttribute("model")
        )
        .subscribe((hvacResponse) => {
          this.hvacModel = hvacResponse;
          /*this.selectedSpeed = this.device.getStateVar('fanSpeed').value;
          this.maxSpeed = Math.max.apply(Math, this.hvacModel.supportFanSpeed);
          this.loading = false;*/
        });
    }
    if (this.scheduleType === SCHEDULE_TYPE.THERMOSTAT) {
      this.termostatModel = true;
    } else {
      this.termostatModel = false;
    }
  }
  addDesiredSchedules(schedules: Schedule[]) {
    this.desiredSchedules = [...this.desiredSchedules, ...schedules].filter(
      (s) => s.getRuleStatus() === RULE_STATUS.DESIRED
    );
  }

  openDialogScheduleType(scheduleType: ScheduleType, schedule: Schedule) {
    this.dialogRef = this.dialog.open(SchedulingCreateDialogComponent, {
      data: {
        schedule: schedule,
        scheduling: this.scheduling,
        schedulingSK: this.schedulingStandbyKiller,
        schedulingEco: this.schedulingEconomic,
        types: [scheduleType],
        hvacModel: this.hvacModel,
        termostatModel: this.termostatModel,
      },
      panelClass: "inputPopup",
    });
    this.openDialogOptions();
  }

  openDialog(schedule?: Schedule): void {
    this.dialogRef = this.dialog.open(SchedulingCreateDialogComponent, {
      data: {
        schedule: schedule,
        scheduling: this.scheduling,
        schedulingSK: this.schedulingStandbyKiller,
        schedulingEco: this.schedulingEconomic,
        types: schedule
          ? [schedule.getType()]
          : this.getDeviceScheduleOptions(),
        hvacModel: this.hvacModel,
        termostatModel: this.termostatModel,
      },
      panelClass: "inputPopup",
    });
    this.openDialogOptions();
  }

  openDialogOptions() {
    const sub = this.dialogRef.componentInstance.action.subscribe(
      (s: Schedule) => {
        if (!s.getId()) {
          s.setModuleId(this.device.getModuleId());
          this.schedulingService
            .createSchedule(this.sessionStateService.getHouse().houseId, s)
            .finally(() => (this.dialogRef.componentInstance.loading = false))
            .subscribe((res) => {
              s.setId(res["ruleId"]);
              if (s.getType() === SCHEDULE_TYPE.ECONOMIC) {
                this.schedulingEconomic.addSchedule(s);
              } else if (s.getType() === SCHEDULE_TYPE.STAND_BY_KILLER) {
                this.schedulingStandbyKiller.addSchedule(s);
              } else {
                this.scheduling.addSchedule(s);
              }
              this.refreshCalendar();
              // const currentRoute = this.router.url;
              // this.router
              //   .navigateByUrl(`/page-not-found`, { skipLocationChange: true })
              //   .then(() => {
              //     this.router.navigateByUrl(`${currentRoute}`);
              //   });
              this.dialogRef.close();
            });
        } else if (s.getId() && s.toDelete) {
          this.schedulingService
            .deleteSchedule(this.sessionStateService.getHouse().houseId, s)
            .finally(() => (this.dialogRef.componentInstance.loading = false))
            .subscribe((res) => {
              if (s.getType() === SCHEDULE_TYPE.ECONOMIC) {
                this.schedulingEconomic.removeSchedule(s);
              } else if (s.getType() === SCHEDULE_TYPE.STAND_BY_KILLER) {
                this.schedulingStandbyKiller.removeSchedule(s);
              } else {
                this.scheduling.removeSchedule(s);
              }
              if (this.viewCalendar) {
                this.refreshCalendar();
              }
              this.dialogRef.close();
            });
        } else if (s.getId() && !s.toDelete) {
          this.schedulingService
            .updateSchedule(this.sessionStateService.getHouse().houseId, s)
            .finally(() => (this.dialogRef.componentInstance.loading = false))
            .subscribe((res) => {
              if (s.getType() === SCHEDULE_TYPE.ECONOMIC) {
                this.schedulingEconomic.updateSchedule(s);
              } else if (s.getType() === SCHEDULE_TYPE.STAND_BY_KILLER) {
                this.schedulingStandbyKiller.updateSchedule(s);
              } else {
                this.scheduling.updateSchedule(s);
              }
              if (this.viewCalendar) {
                this.refreshCalendar();
              }
              this.dialogRef.close();
            });
        }
      }
    );
  }

  onEditSchedule(schedule: Schedule) {
    const toEditschedule = cloneDeep(schedule);
    this.openDialog(toEditschedule);
  }

  onRetrySchedule(schedule: Schedule) {
    const s = cloneDeep(schedule);
    this.loading = true;
    if (!s.getId()) {
      s.setModuleId(this.device.getModuleId());
      this.schedulingService
        .createSchedule(this.sessionStateService.getHouse().houseId, s)
        .finally(() => (this.loading = false))
        .subscribe((res) => {
          s.setId(res["ruleId"]);
          if (s.getType() === SCHEDULE_TYPE.ECONOMIC) {
            this.schedulingEconomic.addSchedule(s);
          } else if (s.getType() === SCHEDULE_TYPE.STAND_BY_KILLER) {
            this.schedulingStandbyKiller.addSchedule(s);
          } else {
            this.scheduling.addSchedule(s);
          }
          if (this.viewCalendar) {
            this.refreshCalendar();
          }
          this.dialogRef.close();
        });
    } else if (s.getId() && s.toDelete) {
      this.schedulingService
        .deleteSchedule(this.sessionStateService.getHouse().houseId, s)
        .finally(() => (this.loading = false))
        .subscribe((res) => {
          if (s.getType() === SCHEDULE_TYPE.ECONOMIC) {
            this.schedulingEconomic.removeSchedule(s);
          } else if (s.getType() === SCHEDULE_TYPE.STAND_BY_KILLER) {
            this.schedulingStandbyKiller.removeSchedule(s);
          } else {
            this.scheduling.removeSchedule(s);
          }
          if (this.viewCalendar) {
            this.refreshCalendar();
          }
          this.dialogRef.close();
        });
    } else if (s.getId() && !s.toDelete) {
      this.schedulingService
        .updateSchedule(this.sessionStateService.getHouse().houseId, s)
        .finally(() => (this.loading = false))
        .subscribe((res) => {
          if (s.getType() === SCHEDULE_TYPE.ECONOMIC) {
            this.schedulingEconomic.updateSchedule(s);
          } else if (s.getType() === SCHEDULE_TYPE.STAND_BY_KILLER) {
            this.schedulingStandbyKiller.updateSchedule(s);
          } else {
            this.scheduling.updateSchedule(s);
          }
          if (this.viewCalendar) {
            this.refreshCalendar();
          }
          this.dialogRef.close();
        });
    }
  }

  private getDeviceScheduleOptions(): SCHEDULE_TYPE[] {
    const scheduleTypes: SCHEDULE_TYPE[] = [];
    scheduleTypes.push(this.scheduleType);
    if (this.device.getGroups().has(GROUP.SWITCH)) {
      scheduleTypes.push(SCHEDULE_TYPE.STAND_BY_KILLER);
      if (
        this.sessionStateService.getHouseTariff().tariff !==
          HOUSE_TARIFF.SIMPLE &&
        !this.schedulingEconomic.hasSchedules()
      ) {
        scheduleTypes.push(SCHEDULE_TYPE.ECONOMIC);
      }
    }
    return scheduleTypes;
  }

  toogleViewCalendar() {
    this.viewCalendar = !this.viewCalendar;
    if (this.viewCalendar) {
      this.refreshCalendar();
    }
  }

  private refreshCalendar(): void {
    const events = this.getCalendar();
    if (this.ucCalendar) {
      this.ucCalendar.fullCalendar("removeEvents");
      this.ucCalendar.fullCalendar("renderEvents", events);
    }
  }

  getCalendar() {
    let events = [];
    this.scheduling.getSchedules().forEach((s) => {
      if (
        (this.showOnOff && !this.isSetPoint()) ||
        (this.showSetpoint && this.isSetPoint())
      ) {
        if (s.getRuleStatus() === RULE_STATUS.DESIRED && this.showInactive) {
          events = events.concat(this.getEvents(s));
        } else if (!s.getState() && this.showDisabled) {
          events = events.concat(this.getEvents(s));
        } else if (s.getRuleStatus() === RULE_STATUS.REPORTED && s.getState()) {
          events = events.concat(this.getEvents(s));
        } else {
          events = events.concat(this.getEvents(s));
        }
      }
    });

    this.schedulingEconomic.getSchedules().forEach((s) => {
      if (this.showEconomic) {
        if (s.getRuleStatus() === RULE_STATUS.DESIRED && this.showInactive) {
          events = events.concat(this.getEvents(s));
        } else if (!s.getState() && this.showDisabled) {
          events = events.concat(this.getEvents(s));
        } else if (s.getRuleStatus() === RULE_STATUS.REPORTED && s.getState()) {
          events = events.concat(this.getEvents(s));
        } else {
          events = events.concat(this.getEvents(s));
        }
      }
    });

    this.schedulingStandbyKiller.getSchedules().forEach((s) => {
      if (this.showStandbyKIller) {
        if (s.getRuleStatus() === RULE_STATUS.DESIRED && this.showInactive) {
          events = events.concat(this.getEvents(s));
        } else if (!s.getState() && this.showDisabled) {
          events = events.concat(this.getEvents(s));
        } else if (s.getRuleStatus() === RULE_STATUS.REPORTED && s.getState()) {
          events = events.concat(this.getEvents(s));
        } else {
          events = events.concat(this.getEvents(s));
        }
      }
    });

    this.calendarOptions = {
      editable: false,
      eventLimit: false,
      allDaySlot: false,
      defaultView: "agendaWeek",
      nowIndicator: true,
      slotLabelFormat: "HH:mm",
      eventColor: "#C1DDA4",
      header: false,
      columnFormat: "dddd",
      slotDuration: moment.duration({ hours: 1 }),
      height: "auto",
      firstDay: 1,
      displayEventTime: false,
      events: events,
      eventTextColor: "#ffffff",
    };
    return events;
  }

  private getEvents(schedule: Schedule) {
    let events = [];
    const fromDate: Date = new Date(`1970-01-01T${schedule.fromTime}:00Z`);
    const toDate: Date = new Date(`1970-01-01T${schedule.toTime}:00Z`);

    if (
      schedule.getType() === SCHEDULE_TYPE.ECONOMIC &&
      schedule.getToTime() === "--:--" &&
      schedule.getFromTime() === "--:--"
    ) {
      this.schedulingService
        .getEconomicScheduling(schedule)
        .getSchedules()
        .forEach((scheduleEconomic) => {
          events = events.concat(this.getEvents(scheduleEconomic));
        });
    }
    if (
      fromDate.getHours() === toDate.getHours() &&
      toDate.getMinutes() - fromDate.getMinutes() < 60
    ) {
      events.push({
        id: schedule.getId(),
        title: this.getEventTitle(schedule),
        start: `${schedule.fromTime.substring(0, 2)}:10`,
        end: `${schedule.toTime.substring(0, 2)}:50`,
        dow: Schedule.weekDaysToNumbers(schedule.getWeekDays()),
        color: this.getColor(schedule),
        icon: this.getOperationModeIconLight(schedule),
        temperature: schedule.getTemperature(),
        ruleStatus: schedule.getRuleStatus(),
      });
    } else if (
      toDate.getHours() - fromDate.getHours() === 1 &&
      new Date(toDate.getTime() - fromDate.getTime()).getTime() < 1800000
    ) {
      events.push({
        id: schedule.getId(),
        title: this.getEventTitle(schedule),
        start: `${schedule.fromTime.substring(0, 2)}:40`,
        end: `${schedule.toTime.substring(0, 2)}:20`,
        dow: Schedule.weekDaysToNumbers(schedule.getWeekDays()),
        color: this.getColor(schedule),
        icon: this.getOperationModeIconLight(schedule),
        temperature: schedule.getTemperature(),
        ruleStatus: schedule.getRuleStatus(),
      });
    } else {
      events.push({
        id: schedule.getId(),
        title: this.getEventTitle(schedule),
        start: schedule.fromTime,
        end: schedule.toTime,
        dow: Schedule.weekDaysToNumbers(schedule.getWeekDays()),
        color: this.getColor(schedule),
        icon: this.getOperationModeIconLight(schedule),
        temperature: schedule.getTemperature(),
        ruleStatus: schedule.getRuleStatus(),
      });
    }

    return events;
  }

  eventClick(event): void {
    // if (event.event.title === '00:00 - 23:59') {
    //   this.onEditSchedule(this.schedulingEconomic.getSchedules()[0]);
    //   return;
    // }

    let schedule: Schedule = this.scheduling
      .getSchedules()
      .find((sch) => sch.getId() === event.event.id);
    if (!schedule) {
      schedule = this.schedulingStandbyKiller
        .getSchedules()
        .find((sch) => sch.getId() === event.event.id);
    }
    if (schedule) {
      this.onEditSchedule(schedule);
    } else {
      this.onEditSchedule(this.schedulingEconomic.getSchedules()[0]);
    }
  }

  eventRender(eventDetail) {
    const retry: string = this.generalService.translate.instant("RETRY");

    if (
      eventDetail.event.icon &&
      eventDetail.event.ruleStatus === RULE_STATUS.REPORTED
    ) {
      eventDetail.element
        .find(".fc-title")
        .append(
          '<span class="eventtemp">' +
            eventDetail.event.temperature +
            "? " +
            "<img src=" +
            eventDetail.event.icon +
            ">" +
            "</span>"
        );
    }
    if (eventDetail.event.ruleStatus === RULE_STATUS.DESIRED) {
      eventDetail.element
        .find(".fc-title")
        .replaceWith(
          '<img styles="float:right" src=' +
            "./assets/img/icons/ic-routines-alert.svg" +
            ">" +
            '<span class="retryTitle">' +
            retry +
            "</span>"
        );
    }
  }

  getEventTitle(schedule) {
    switch (schedule.getType()) {
      case SCHEDULE_TYPE.ECONOMIC: {
        return "ECONOMIC";
      }
      default: {
        return `${schedule.fromTime} - ${schedule.toTime}`;
      }
    }
  }

  getOperationModeIconLight(schedule) {
    if (schedule.getType() === SCHEDULE_TYPE.HVAC) {
      switch (schedule.getMode()) {
        case MODE.OFF: {
          return "./assets/img/icons/ic-ac-mode-fan-off-light.svg";
        }
        case MODE.AUTO: {
          return "./assets/img/icons/ic-ac-mode-fan-auto-light.svg";
        }
        case MODE.HEAT: {
          return "./assets/img/icons/ic-ac-mode-heat-light.svg";
        }
        case MODE.COOL: {
          return "./assets/img/icons/ic-ac-mode-cold-light.svg";
        }
        case MODE.DRY: {
          return "./assets/img/icons/ic-ac-mode-fan-dry-light.svg";
        }
        case MODE.FAN: {
          return "./assets/img/icons/ic-ac-mode-fan-light.svg";
        }
        default: {
          return "";
        }
      }
    } else if (schedule.getType() === SCHEDULE_TYPE.THERMOSTAT) {
      return "./assets/img/icons/ic-ac-mode-heat-light.svg";
    }
  }

  getOperationModeIcon(schedule) {
    if (schedule.getType() === SCHEDULE_TYPE.HVAC) {
      switch (schedule.getMode()) {
        case MODE.OFF: {
          return "./assets/img/icons/ic-ac-mode-fan-off.svg";
        }
        case MODE.AUTO: {
          return "./assets/img/icons/ic-ac-mode-fan-auto.svg";
        }
        case MODE.HEAT: {
          return "./assets/img/icons/ic-ac-mode-heat.svg";
        }
        case MODE.COOL: {
          return "./assets/img/icons/ic-ac-mode-cold.svg";
        }
        case MODE.DRY: {
          return "./assets/img/icons/ic-ac-mode-fan-dry.svg";
        }
        case MODE.FAN: {
          return "./assets/img/icons/ic-ac-mode-fan.svg";
        }
        default: {
          return "";
        }
      }
    } else if (schedule.getType() === SCHEDULE_TYPE.THERMOSTAT) {
      return "./assets/img/icons/ic-ac-mode-heat.svg";
    }
  }

  getOperationModeIconDark(schedule) {
    if (schedule.getType() === SCHEDULE_TYPE.HVAC) {
      switch (schedule.getMode()) {
        case MODE.OFF: {
          return "./assets/img/icons/ic-ac-mode-fan-off-dark.svg";
        }
        case MODE.AUTO: {
          return "./assets/img/icons/ic-ac-mode-fan-auto-dark.svg";
        }
        case MODE.HEAT: {
          return "./assets/img/icons/ic-ac-mode-heat-dark.svg";
        }
        case MODE.COOL: {
          return "./assets/img/icons/ic-ac-mode-cold-dark.svg";
        }
        case MODE.DRY: {
          return "./assets/img/icons/ic-ac-mode-fan-dry-dark.svg";
        }
        case MODE.FAN: {
          return "./assets/img/icons/ic-ac-mode-fan-dark.svg";
        }
        default: {
          return "";
        }
      }
    } else if (schedule.getType() === SCHEDULE_TYPE.THERMOSTAT) {
      return "./assets/img/icons/ic-ac-mode-heat-dark.svg";
    }
  }

  getColor(schedule: Schedule) {
    if (schedule.getRuleStatus() === RULE_STATUS.DESIRED) {
      return EVENT_COLOR.DESIRED;
    }
    if (schedule.getState() || schedule.getType() === SCHEDULE_TYPE.ECONOMIC) {
      switch (schedule.getType()) {
        case SCHEDULE_TYPE.ON_OFF: {
          return EVENT_COLOR.ON_OFF;
        }
        case SCHEDULE_TYPE.ECONOMIC: {
          return EVENT_COLOR.ECONOMIC;
        }
        case SCHEDULE_TYPE.HVAC: {
          return EVENT_COLOR.HVAC;
        }
        case SCHEDULE_TYPE.THERMOSTAT: {
          return EVENT_COLOR.THERMOSTAT;
        }
        case SCHEDULE_TYPE.STAND_BY_KILLER: {
          return EVENT_COLOR.STAND_BY_KILLER;
        }
        default: {
          return "";
        }
      }
    } else if (!schedule.getState()) {
      return EVENT_COLOR.DISABLED;
    }
    return "";
  }
  getScheduleIcon(schedule): string {
    switch (schedule.getType()) {
      case SCHEDULE_TYPE.HVAC: {
        return schedule.getState()
          ? "../../../../../../assets/img/icons/ic-schedule-setpoint.svg"
          : "../../../../../../assets/img/icons/ic-schedule-setpoint-disabled.svg";
      }
      case SCHEDULE_TYPE.THERMOSTAT: {
        return schedule.getState()
          ? "../../../../../../assets/img/icons/ic-schedule-setpoint.svg"
          : "../../../../../../assets/img/icons/ic-schedule-setpoint-disabled.svg";
      }
      case SCHEDULE_TYPE.STAND_BY_KILLER: {
        return schedule.getState()
          ? "../../../../../../assets/img/icons/ic-schedule-standbykiller.svg"
          : "../../../../../../assets/img/icons/ic-schedule-standbykiller-disabled.svg";
      }
      case SCHEDULE_TYPE.ECONOMIC: {
        return schedule.getState()
          ? "../../../../../../assets/img/icons/ic-schedule-economic.svg"
          : "../../../../../../assets/img/icons/ic-schedule-economic-disabled.svg";
      }
      case SCHEDULE_TYPE.ON_OFF: {
        return schedule.getState()
          ? "../../../../../../assets/img/icons/ic-schedule-onoff.svg"
          : "../../../../../../assets/img/icons/ic-schedule-onoff-disabled.svg";
      }
    }
  }

  getScheduleInactiveIcon(schedule): string {
    switch (schedule.getType()) {
      case SCHEDULE_TYPE.HVAC: {
        return "../../../../../../assets/img/icons/ic-schedule-setpoint-inactive.svg";
      }
      case SCHEDULE_TYPE.THERMOSTAT: {
        return "../../../../../../assets/img/icons/ic-schedule-setpoint-inactive.svg";
      }
      case SCHEDULE_TYPE.STAND_BY_KILLER: {
        return "../../../../../../assets/img/icons/ic-schedule-standbykiller-inactive.svg";
      }
      case SCHEDULE_TYPE.ECONOMIC: {
        return "../../../../../../assets/img/icons/ic-schedule-economic-inactive.svg";
      }
      case SCHEDULE_TYPE.ON_OFF: {
        return "../../../../../../assets/img/icons/ic-schedule-onoff-inactive.svg";
      }
    }
  }

  isSetPoint(): boolean {
    return this.scheduleType !== SCHEDULE_TYPE.ON_OFF;
  }

  changeState(schedule: Schedule) {
    const newState = !schedule.getState();
    this.schedulingService
      .updateState(
        this.sessionStateService.getHouse().houseId,
        schedule,
        newState
      )
      .subscribe((res) => {
        schedule.setState(!schedule.getState());
        if (schedule.getType() === SCHEDULE_TYPE.ECONOMIC) {
          this.schedulingEconomic.updateSchedule(schedule);
        } else if (schedule.getType() === SCHEDULE_TYPE.STAND_BY_KILLER) {
          this.schedulingStandbyKiller.updateSchedule(schedule);
        } else {
          this.scheduling.updateSchedule(schedule);
        }
      });
  }

  isShowAllSchedules(): boolean {
    return (
      this.showOnOff &&
      this.showEconomic &&
      this.showSetpoint &&
      this.showDisabled &&
      this.showInactive &&
      this.showStandbyKIller
    );
  }

  toggleAll() {
    const isShowAllSchedules = !this.isShowAllSchedules();

    this.showOnOff = isShowAllSchedules;
    this.showEconomic = isShowAllSchedules;
    this.showSetpoint = isShowAllSchedules;
    this.showDisabled = isShowAllSchedules;
    this.showInactive = isShowAllSchedules;
    this.showStandbyKIller = isShowAllSchedules;
    if (this.viewCalendar) {
      this.refreshCalendar();
    }
  }

  toggleShowOnOff() {
    this.showOnOff = !this.showOnOff;
    if (this.viewCalendar) {
      this.refreshCalendar();
    }
  }

  toggleEconomic() {
    this.showEconomic = !this.showEconomic;
    if (this.viewCalendar) {
      this.refreshCalendar();
    }
  }

  toggleStandbyKIller() {
    this.showStandbyKIller = !this.showStandbyKIller;
    if (this.viewCalendar) {
      this.refreshCalendar();
    }
  }

  toggleSetpoint() {
    this.showSetpoint = !this.showSetpoint;
    if (this.viewCalendar) {
      this.refreshCalendar();
    }
  }

  toggleDisabled() {
    this.showDisabled = !this.showDisabled;
    if (this.viewCalendar) {
      this.refreshCalendar();
    }
  }

  toggleInactive() {
    this.showInactive = !this.showInactive;
    if (this.viewCalendar) {
      this.refreshCalendar();
    }
  }

  getTranslateSchedule(schedule: Schedule) {
    const days = SchedulingUtils.formatScheduleForDeviceDetail(schedule).split(
      " "
    );
    let result = "";
    days.forEach((day) => {
      if (day !== "") {
        result = result + this.generalService.translate.instant(day) + " ";
      }
    });
    return result;
  }

  deleteSchedule(schedule: Schedule) {
    this.dialogDelRef = this.dialog.open(DeleteConfirmDialogComponent, {
      data: {
        element: "SCHEDULE",
        message:
          schedule.getType() !== SCHEDULE_TYPE.ECONOMIC
            ? `Schedule ${schedule.getType()} with horary: ${schedule.getHorary()}
        ${this.generalService.translate.instant(
          "will be permanently deleted."
        )}`
            : `Schedule ${schedule.getType()} ${this.generalService.translate.instant(
                "will be permanently deleted."
              )}`,
      },
      autoFocus: false,
      panelClass: "deleteGenericPopup",
    });

    const sub = this.dialogDelRef.componentInstance.action.subscribe(
      (toDelete: boolean) => {
        if (toDelete) {
          schedule.toDelete = true;
          this.schedulingService
            .deleteSchedule(
              this.sessionStateService.getHouse().houseId,
              schedule
            )
            .subscribe((res) => {
              if (schedule.getType() === SCHEDULE_TYPE.ECONOMIC) {
                this.schedulingEconomic.removeSchedule(schedule);
              } else if (schedule.getType() === SCHEDULE_TYPE.STAND_BY_KILLER) {
                this.schedulingStandbyKiller.removeSchedule(schedule);
              } else {
                this.scheduling.removeSchedule(schedule);
              }
              if (this.viewCalendar) {
                this.refreshCalendar();
              }
            });
        }
      }
    );
  }

  getLang() {
    return this.sessionStateService.getLang();
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/scheduling/scheduling-device/scheduling-device.component.ts